export default "__VITE_ASSET__ac9401f3__"